<style lang="scss" src='./SensorAlerts.scss' scoped></style>
<template src="./SensorAlerts.html"></template>

<script>
import {
  GetOpenedAlertBySensor,
} from '@/api/index';

import { mapMutations, mapState } from 'vuex';
import AlertDetails from './alertDetails/AlertDetails.vue';

export default {
  name: 'SensorAlerts',
  components:{
    AlertDetails,
  },
  props: {
    sensor: {
      required: false,
    },
  },
  data() {
    return ({
      alerts: [],
      loading: false,
      selectedAlert: null,
    });
  },

  computed:{
    ...mapState('sensors', ['showAlertList']),
    ...mapState('sensors', {
      rssiRanges: (state) => state.rssiRanges,
    }),
  },

  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && oldSensor && newSensor.sensor_id !== oldSensor.sensor_id) {
        this.loadData();
        this.setShowAlertList(true);
      }
    }
  },

  methods: {
    getAlertTypeIcon(alertTypeId) {
      // eslint-disable-next-line
      return require(`@/assets/img/alert/${alertTypeId}.png`);
    },

    getRssiIcon(alert) {
      // eslint-disable-next-line
      return require(`@/assets/img/sensor/${this.G_getRssiIcon(alert.sensor, this.rssiRanges)}`);
    },

    getProbeDisconnectedIcon() {
      return require(`@/assets/img/alert/UNPLUGGED.png`);
    },

    async loadAlerts() {
      this.loading = true;
      this.alerts = [];
      const alertResponse = await GetOpenedAlertBySensor(this.sensor.sensor_id);
      if (alertResponse) {
        this.alerts = alertResponse.alerts;
      }
      this.loading = false;
    },

    loadData() {
      if (this.sensor){
        this.loadAlerts();
        this.setShowAlertList(true);
      }
    },

    getThresholdViolation(alert) {
      let minMax = "min_";
      const alertType = this.consts.AlertType[alert.alert_type_id];
      if (alert.violation === 'READING_HIGH') {
        minMax = "max_";
      }
      return this.G_getMeasurement({ val: alert.sensor.threshold[minMax + alertType.key],
                                    uom: alert.alert_type.uom,
                                    addUnit: true, invertUOM: false });

    },

    showAlertDetails(alert){
      this.selectedAlert = alert;
      this.setShowAlertList(false);
    },

    ...mapMutations('sensors', ['setShowAlertList'])
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sensors Alerts");
      this.$analytics.logEvent("web_sensors_alerts");
    }

    this.loadData();
  },

  beforeDestroy(){
    this.setShowAlertList(true)
  }
};
</script>
